import React, { useState, useEffect, useCallback } from 'react';
import { WebUI, getNid } from "../../wui-core/src/index"
import Icon from '../../wui-icon/src';
import { BackTopProps } from './iBackTop';
import { WithConfigConsumer } from '../../wui-provider/src/context';

// const propTypes = {
//     visibilityHeight: PropTypes.number,
//     click: PropTypes.func,
//     target: PropTypes.func,
//     fieldid: PropTypes.string,
//     character: PropTypes.element
// };
const defaultProps: BackTopProps = {
    visibilityHeight: 400,
    click: () => {
    },
    target: () => window,
    character: <Icon type="uf-top-up"/>
};

const BackTopComponent: React.FC<BackTopProps> = (props) => {
    const [show, setShow] = useState(false);

    const scroll = useCallback(() => {
        const targetElement = props.target() as HTMLElement;
        targetElement.onscroll = function() {
            if (((props.target() as Window).scrollY || (props.target() as HTMLElement).scrollTop) >= props.visibilityHeight) {
                setShow(true);
            } else {
                setShow(false);
            }
        }
    }, []);

    const click = useCallback(() => {
        const height = (props.target() as Window).scrollY || (props.target() as HTMLElement).scrollTop;

        const timer = (height: number) => {
            const h = Math.floor(height / 3);
            props.target().scrollTo ? props.target().scrollTo(0, h) : (props.target() as HTMLElement).scrollTop = h;

            if (h > 0) {
                window.clearInterval((window as any).backTopTimer);
                (window as any).backTopTimer = window.setInterval(() => {
                    timer(h);
                }, 90);
            } else {
                setShow(false);
                window.clearInterval((window as any).backTopTimer);
                return;
            }
        };

        timer(height);
        props.click();
    }, []);

    useEffect(() => {
        scroll();
    }, [scroll]);

    // 使用了 others不能包含 visibilityHeight click character
    // eslint-disable-next-line no-unused-vars
    const {className: propClassName, children, visibilityHeight, click: propClick, target, character, clsPrefix, fieldid, dir, ...others} = props;

    let className = propClassName ? propClassName : '';
    className = !show
        ? `${clsPrefix} ${clsPrefix}-hide ` + (target() === window ? '' : `${clsPrefix}-dom `) + className
        : `${clsPrefix} ` + (target() === window ? '' : `${clsPrefix}-dom `) + className;

    const adapterNid = getNid(props);

    return (
        <span {...others} fieldid={fieldid} className={className} onClick={click} {...adapterNid}>
            {children ? children : props.character}
        </span>
    );
};

const BackTop = WithConfigConsumer()(WebUI({name: "back-top", defaultProps})(BackTopComponent));

// BackTop.propTypes = propTypes;
export default BackTop as React.ComponentClass<Partial<BackTopProps>>;
